import { useState } from "react";
import { useSyncState } from "@/hooks/use-sync-state";
const EMPTY_LIST = [];
function emptyList() {
  return EMPTY_LIST;
}
export function usePaginatedItems(initialState, queryFn, {
  upToCount,
  onPaginationCompleted
} = {}) {
  const [nextPageCursor, setNextPageCursor] = useSyncState(initialState?.nextPageCursor);
  const [items, setItems] = useSyncState(initialState?.items ?? emptyList());
  const [isLoadingNext, setIsLoadingNext] = useState(false);
  const hasNext = upToCount ? items.length < upToCount && Boolean(nextPageCursor) : Boolean(nextPageCursor);
  async function loadNext() {
    if (!nextPageCursor || isLoadingNext) {
      return;
    }
    const start = Date.now();
    setIsLoadingNext(true);
    try {
      const result = await queryFn(nextPageCursor);
      setItems(prev => [...prev, ...(result?.items ?? [])]);
      setNextPageCursor(result?.nextPageCursor);
      if (onPaginationCompleted) {
        const duration = Date.now() - start;
        onPaginationCompleted(start, duration);
      }
    } finally {
      setIsLoadingNext(false);
    }
  }
  const pagination = {
    hasNext,
    loadNext,
    isLoadingNext
  };
  return [items, setItems, pagination];
}